import './Modal.scss';
import React, { ReactNode } from 'react';
import 'react-responsive-modal/styles.css';

import { Modal as ModalPkg } from 'react-responsive-modal';
import { Separator, Typography } from '@design-system';

export type ModalProps = {
    open: boolean;
    setClose: () => void;
    title: string;
    titleIcon?: ReactNode;
    footer?: ReactNode;
    fitContent?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Modal: React.FC<ModalProps> = ({ open, setClose, title, titleIcon, children, footer, fitContent, ...props }) => {
    return (
        <div>
            <ModalPkg open={open} onClose={setClose} center>
                <div className="modal" {...props} data-fit-content={fitContent}>
                    {title && (
                        <Typography className="modal-title" intrinsic="h4">
                            {titleIcon && <span className="modal-title-icon">{titleIcon}</span>}
                            {title}
                        </Typography>
                    )}

                    <div className="body">{children}</div>

                    {footer && (
                        <>
                            <Separator />
                            <div className="footer">{footer}</div>
                        </>
                    )}
                </div>
            </ModalPkg>
        </div>
    );
};
